import { nextTick } from 'vue';
import { PriorityQueryKey, TypeQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { Route } from '@/modules/core/enums/route.enum.ts';
import { queryClient } from '@/tanstack-query.ts';
import { useViewerStore } from '@/modules/viewer/stores/viewer.store.ts';
import { CounterpartyQueryOptions } from '@/modules/counterparty/query-options/counterparty.query-options.ts';

const COUNTERPARTIES_QUERY_KEY = [PriorityQueryKey.Primary, CounterpartyQueryOptions.BASE_KEY];
const COUNTERPARTIES_COUNT_QUERY_KEY = [
  PriorityQueryKey.Primary,
  CounterpartyQueryOptions.BASE_KEY,
  TypeQueryKey.Count,
] as const;

type RefreshCounterpartiesListOptions = {
  created?: boolean;
};

export async function refreshCounterpartiesList(options: RefreshCounterpartiesListOptions = {}) {
  const viewerStore = useViewerStore();

  let countFloor: number | undefined;

  if (options.created) {
    const current = queryClient.getQueryData<number>(COUNTERPARTIES_COUNT_QUERY_KEY);
    countFloor = typeof current === 'number' ? current + 1 : 1;
  }

  if (viewerStore.hasFirstPageLimit(Route.CounterpartiesPage)) {
    viewerStore.resetFirstPageLimit(Route.CounterpartiesPage);
    await nextTick();
  }

  await queryClient.invalidateQueries({ queryKey: COUNTERPARTIES_QUERY_KEY }).catch(() => undefined);

  if (countFloor != null) {
    queryClient.setQueryData<number>(COUNTERPARTIES_COUNT_QUERY_KEY, (prev) =>
      typeof prev === 'number' ? Math.max(prev, countFloor) : countFloor
    );
  }
}
